import { useEffect, useState } from "react";
import { useTableConfigNotice } from "../../services/config";
import { IMGBUCKETURL } from "../../DataStore/ApiConstant";

const PoyaBanneer = () => {
  let poya = useTableConfigNotice();
  const [active, setActive] = useState(false);
  const [image, setImage] = useState("");

  useEffect(() => {
    if (poya.isLoading || !poya?.data?.length) {
      setActive(false);
      return;
    }

    const poyaBanner = poya.data.find((item) => item.type === "poya");

    if (poyaBanner) {
      setActive(true);
      setImage(poyaBanner.image);
    } else {
      setActive(false);
    }
  }, [poya.isLoading, poya.data]);

  return (
    <>
      {active && (
        <div
          className={`modal fade ${active ? "show d-block" : ""}`} // Ensures modal is visible
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          style={{ backgroundColor: "#000000a1" }}
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              setActive(false);
            }
          }}
        >
          <div
            className="modal-dialog modal-dialog-scrollable showModalcontent"
            style={{ maxWidth: "800px", width: "95vw" }}
          >
            <div className="modal-content" style={{ backgroundColor: "transparent" }}>
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close ms-auto" // Moves button to right side
                  onClick={() => setActive(false)}
                  style={{
                    backgroundColor: "white",
                    position: "relative", // Ensures it stays inside modal header
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <img
                  className="img-fluid"
                  alt=""
                  src={`${IMGBUCKETURL + image}`}
                />
              </div>
              <div className="modal-footer"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PoyaBanneer;
